import React from 'react'

function Genres() {
  return (
    <div className="flex flex-col ml-36">Genres</div>
  )
}

export default Genres